import { resources, i18n } from '@askable/i18n';
import { initI18nZodMap, isLocale } from '@askableorg/i18n';
import { initReactI18next } from 'react-i18next';
import { z } from 'zod';

import { Locale } from '@/constants/graphql-enums';
import { requestedLocale, setLangCookie } from '@/utils/lang-utils';

const resolveInitialLang = (): string => {
  if (typeof window === 'undefined') {
    return Locale.En;
  }

  // The participant app sends its language in `?lang=`. A guest has no user record to read, and
  // the webview starts in the language of the device. The cookie keeps the value, because the
  // study flow navigates the full page and removes the query string.
  if (requestedLocale) {
    setLangCookie(requestedLocale);
    return requestedLocale;
  }

  return (
    document.cookie
      .split('; ')
      .find(row => row.startsWith('lang='))
      ?.split('=')[1] ??
    window.localStorage.getItem('lang') ??
    navigator.language ??
    Locale.En
  );
};

const initialLang = resolveInitialLang();

export const initialLocale = (isLocale(initialLang) ? initialLang.replace('-', '_') : Locale.En) as Locale;

void i18n.use(initReactI18next).init({
  lng: initialLang,
  fallbackLng: 'en',
  ns: ['sessions', 'common', 'zod', 'components', 'docbuilder'],
  resources,
  // React escapes everything it renders, so i18next escaping interpolated values on top of
  // that double-encodes them - a category named "Account & Support" reached the UI as
  // "Account &amp; Support". Nothing here feeds translated output into innerHTML.
  interpolation: { escapeValue: false },
});

z.setErrorMap(initI18nZodMap(i18n));

export { z };
export default i18n;
